import type { LucideIcon } from 'lucide-react';
import {
  ShoppingBag, Package, Fan, Building2, ShoppingCart, ClipboardList,
  CheckSquare, KeyRound, CalendarClock, Flame, PanelTop, Zap, FileSearch,
} from 'lucide-react';

// Icon shown in the thumbnail frame whenever a result has no thumbnailUrl -- never a broken
// image. One per type; falls back to a generic search icon for anything unlisted.
export const TYPE_ICONS: Record<string, LucideIcon> = {
  catalogue: ShoppingBag,
  supply: Package,
  equipment: Fan,
  vendor: Building2,
  order: ShoppingCart,
  work_order: ClipboardList,
  task: CheckSquare,
  key: KeyRound,
  schedule: CalendarClock,
  extinguisher: Flame,
  breaker_panel: PanelTop,
  breaker: Zap,
};

export function typeIcon(type: string): LucideIcon {
  return TYPE_ICONS[type] ?? FileSearch;
}
